import { HttpClient } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { Observable } from "rxjs"
import { Rol } from "./api.types";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class RolService {
  // private basePath = `https://alicorp-back.herokuapp.com/api/role/`
  private basePath = `${environment.baseUrl}/api/role/`

  constructor(
    private readonly http: HttpClient,
  ) {}

  getAll(): Observable<Rol[]> {
    return this.http.get<Rol[]>(`${this.basePath}`);
  }

  getBy(id: number): Observable<Rol[]> {
    return this.http.get<Rol[]>(`${this.basePath}${id}`);
  }
  
  create(rol: Rol): Observable<Rol[]> {
    return this.http.post<Rol[]>(`${this.basePath}create`, rol);
  }

  edit(rol: Rol): Observable<Rol> {
    return this.http.put<Rol>(`${this.basePath}update/${rol.id}`, rol);
  }

  delete(id: number): Observable<Rol> {
    return this.http.delete<Rol>(`${this.basePath}delete/${id}`);
  }
}
